import React, { memo } from "react";
import { Flex, Text, AccordionList, Accordion } from "onefaceui-react-components";

import { toDollarFormat } from "react/utils/utils";

const DriverPendingBalances = ({ driverPendingBalanceArray, i18n }) => {

  let total = {amount: 0, quantity: 0};

  driverPendingBalanceArray.map(item => {
    if(item.quantity === undefined){
      total.amount += item.amount;
    } else {
      total.quantity += item.quantity;
    }
  });

  const accordItem = attr => {
    return (
      <Accordion
        customHeaderComponent={
          <Flex
            style={{ flex: 1 }}
            justifyContent="space-between"
            alignItems="center"
          >
            <Text
              type="primary"
              overflow="ellipsis"
            >
              {i18n.getResourcesByKey('driver.balance.total.string')}
            </Text>
            <Text type="primary" weight="bold">{toDollarFormat(total[attr])}</Text>
          </Flex>
        }
      >
        {driverPendingBalanceArray.map(item => {
          if (attr === "amount" && item.quantity === undefined) {
            return (
              <div className="descriptionContainer">
                <div className="description">{item.description}</div>
                <div className="value">{toDollarFormat(item.amount)}</div>
              </div>
            );
          } else if (attr === "quantity" && item.quantity != undefined) {
            return (
              <div className="descriptionContainer">
                <div className="description">{item.description}</div>
                <div className="value">{toDollarFormat(item.quantity)}</div>
              </div>
            );
          }
        })}
      </Accordion>
    );
  };

  const list = (
    <AccordionList size="md">
      {accordItem("amount")}
      {accordItem("quantity")}
    </AccordionList>
  );

  return (
    <div id="driverPendingBalancesContainer">
      {list}
    </div>
  );
};

export default memo(DriverPendingBalances);
